// ── 출퇴근 필터 팝오버 (2026-09-01 사용자 명세) ─────────────────────────────────
// 검색창 옆 검정 필터 버튼 → 팝오버(IP 별칭·년·월). 필터가 기본값과 다르면 버튼에
// 설정된 개수(예: 2)와 X가 붙고, X를 누르면 초기화(IP 전체·현재 년월)된다.
// 차단형 모달 아님(드롭다운) — 스크롤 잠금 없이 투명 클릭아웃으로 닫는다.
// 통합 메뉴면 맨 위에 "회사" 칸(companyFilter, 2026-09-30 — 제목 아래 칩을 이 안으로). 일부만 고르면 1개로 센다.
// 위 [‹ 2026년 10월 ›][오늘](2026-10-13)과 같은 달 값을 쓴다 — 여기서 8월을 고르면 위도 8월, 위에서 넘기면 여기도 그 달로 보인다.
import React, { useState } from 'react';
import { Filter, X } from 'lucide-react';
import { nowKST } from '../../../utils/date';
import { inputStyle } from './styles';
import { stdBlackBtn } from '../adminlayout/designStandard';
import { CompanyFilterField, companyFilterActive, companyFilterUsable, resetCompanyFilter } from '../attendancehub/CompanyFilterField';

export function AttendanceFilterPopover({
  isMobile, ipFilter, setIpFilter, ipFilterOptions,
  year, setYear, month, setMonth, yearOptions, monthsForYear,
  // 달력 탭에서 이름을 눌러 특정 달로 왔을 때(2026-09-29) — 그 년·월을 "골라 둔" 상태로 보여 준다(배지·X 초기화).
  presetMonth = false,
  // 위 [‹ ›][오늘] 로 달을 넘긴 적이 있으면 고르기 칸에 지금 달을 보여 준다(안 넘겼으면 예전처럼 '년도/월 선택').
  //   배지 개수는 예전 규칙 그대로 — 여기서 직접 고른 것만 센다.
  monthShown = false,
  companyFilter = null,
}) {
  const [open, setOpen] = useState(false);
  // 배지 = "직접 선택한" 필터 개수 (2026-09-01 사용자 확정: 현재 년/월을 골라도 선택했으면 센다).
  //   년 변경 시 자동으로 맞춰지는 월(스냅)은 직접 선택이 아니므로 세지 않는다.
  const [yearTouched, setYearTouched] = useState(Boolean(presetMonth));
  const [monthTouched, setMonthTouched] = useState(Boolean(presetMonth));

  // 초기화 기본값 = IP 전체 + 현재 년·월 (nowKST: utils/date.js — new Date 직접 사용 금지)
  const n = nowKST();
  const activeCount = (ipFilter ? 1 : 0) + (yearTouched ? 1 : 0) + (monthTouched ? 1 : 0)
    + (companyFilterActive(companyFilter) ? 1 : 0);

  // 위에서 넘긴 달이 기록 없는 달이어도 고르기 칸에 보이게 지금 년·월을 목록에 끼워 넣는다(2026-10-13).
  const yearList = yearOptions(year).includes(year) ? yearOptions(year) : [...yearOptions(year), year].sort((a, b) => b - a);
  const monthList = monthsForYear(year).includes(month) ? monthsForYear(year) : [...monthsForYear(year), month].sort((a, b) => a - b);

  function resetFilters() {
    setIpFilter('');
    resetCompanyFilter(companyFilter);
    setYear(n.getUTCFullYear());
    setMonth(n.getUTCMonth() + 1);
    setYearTouched(false);
    setMonthTouched(false);
    setOpen(false);
  }

  return (
    <div style={{ position: 'relative', flexShrink: 0 }}>
      <button
        style={{
          ...stdBlackBtn, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
          height: 40, width: activeCount > 0 ? 'auto' : 44, padding: activeCount > 0 ? '0 12px' : 0,
        }}
        onClick={() => setOpen((v) => !v)}
        aria-label="필터"
        title={companyFilterUsable(companyFilter) ? '필터 (회사·IP 별칭·년도·월)' : '필터 (IP 별칭·년도·월)'}
      >
        <Filter size={16} />
        {activeCount > 0 && (
          <>
            <span style={{ fontSize: 13, fontWeight: 800 }}>{activeCount}</span>
            {/* X = 필터 초기화 — 버튼 안의 중첩 클릭이라 팝오버 토글로 번지지 않게 차단 */}
            <span
              role="button"
              aria-label="필터 초기화"
              title={companyFilterUsable(companyFilter) ? '필터 초기화 (전체 회사·전체·현재 월로 복귀)' : '필터 초기화 (전체·현재 월로 복귀)'}
              onClick={(e) => { e.stopPropagation(); resetFilters(); }}
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18,
                borderRadius: 6, background: 'rgba(255,255,255,0.22)', cursor: 'pointer',
              }}
            >
              <X size={12} />
            </span>
          </>
        )}
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 900 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: 46, right: isMobile ? 0 : 'auto', left: isMobile ? 'auto' : 0,
            zIndex: 901, width: 240, background: 'var(--bg-card)', border: '1px solid var(--border)',
            borderRadius: 12, boxShadow: '0 12px 32px rgba(15,27,53,0.14)', padding: 14,
            display: 'grid', gap: 10,
          }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--text)' }}>필터</div>
            <CompanyFilterField companyFilter={companyFilter} />
            {/* IP 별칭 — 옵션 0건이면 '전체'만 (테넌트는 플랫폼 IP 데이터 차단으로 항상 0건) */}
            <select style={inputStyle} value={ipFilter} onChange={(e) => setIpFilter(e.target.value)}>
              <option value="">IP 별칭 전체</option>
              {ipFilterOptions.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
            {/* 데이터 있는 년·월만 표시 — 년 변경 시 없는 월이면 최근 월로 자동 이동.
                미선택 시 placeholder('년도/월 선택') 표시: 이미 선택된 값(현재 월)을 다시 골라도
                change 이벤트가 발생하게 하기 위함 — 같은 값 재선택은 네이티브 셀렉트가 이벤트를 안 쏜다. */}
            <select
              style={inputStyle}
              value={yearTouched || monthShown ? year : ''}
              onChange={(e) => {
                const y = Number(e.target.value);
                setYear(y);
                setYearTouched(true);
                const ms = monthsForYear(y);
                if (!ms.includes(month)) setMonth(ms[ms.length - 1]);
              }}
            >
              <option value="" disabled hidden>년도 선택</option>
              {yearList.map((y) => <option key={y} value={y}>{`${y}년`}</option>)}
            </select>
            <select
              style={inputStyle}
              value={monthTouched || monthShown ? month : ''}
              onChange={(e) => { setMonth(Number(e.target.value)); setMonthTouched(true); }}
            >
              <option value="" disabled hidden>월 선택</option>
              {monthList.map((m) => <option key={m} value={m}>{`${m}월`}</option>)}
            </select>
          </div>
        </>
      )}
    </div>
  );
}

export default AttendanceFilterPopover;
